import { Message } from "rsuite";

export const showMessage = (type, message) => {
    return(
    <Message showIcon type={type} closable>
      {message}
    </Message>
  )};